import type { ReactNode } from "react";
import type { AriaSpan } from "@alm/domain/legal";
import { BAA_URL } from "@alm/domain/legal";

export type LegalLink = (text: string, href: string) => ReactNode;

export const plainLink: LegalLink = (text, href) => (
  <a href={href} className="text-primary underline underline-offset-4">
    {text}
  </a>
);

const BAA_MENTION = /(Appendix B|Business Associate Agreement)/;

/** Inline text of a clause. Mentions of the BAA link to its page when `linkBaa` is on. */
export function LegalSpans({
  spans,
  link,
  linkBaa,
}: {
  spans: readonly AriaSpan[];
  link: LegalLink;
  linkBaa: boolean;
}) {
  return spans.map((span, index) => {
    const key = `span-${index}`;
    if (span.k === "strong") return <strong key={key}>{span.text}</strong>;
    if (span.k === "em") return <em key={key}>{span.text}</em>;
    if (span.k === "link") return <span key={key}>{link(span.text, span.href)}</span>;
    if (!linkBaa) return <span key={key}>{span.text}</span>;
    return (
      <span key={key}>
        {span.text.split(BAA_MENTION).map((part, at) =>
          // oxlint-disable-next-line react/no-array-index-key -- legal text rendered once from static data, never reordered
          BAA_MENTION.test(part) ? <span key={`baa-${at}`}>{link(part, BAA_URL)}</span> : part,
        )}
      </span>
    );
  });
}
